import { createSlice } from "@reduxjs/toolkit";
import moment from "moment/moment";

const currentDate = moment().add(2, "day").startOf("day").format("DD/MM/YYYY");
const nextDate = moment().add(3, "day").endOf("day").format("DD/MM/YYYY");

export const searchCardData = createSlice({
  name: "searchCardData",
  initialState: {
    placeData: {},
    searchCardData: {
      destinationName: "",
      checkIn: currentDate,
      checkOut: nextDate,
      guestDetails: {
        rooms: 1,
        childAge: [],
        adults: 2,
        children: 0,
      },
    },
    roomBillingDetails: {},
    searchToggle: 0,
  },
  reducers: {
    setPlaceData: (state, action) => {
      state.placeData = action.payload;
    },
    setSearchCardData: (state, action) => {
      if (convertToProperDate(action.payload.checkIn) < convertToProperDate(new Date().toLocaleDateString())) {
        action.payload.checkIn = currentDate;
        action.payload.checkOut = nextDate;
      }
      state.searchCardData = action.payload;
    },
    setSelectedRoomRate: (state, action) => {
      state.roomBillingDetails = action.payload;
    },
    setSearchToggle: (state, action) => {
      state.searchToggle = action.payload;
    },
    setSearchCardFocus: (state, action) => {
      state.searchCardFocus = action.payload;
    }
  },
});

function convertToProperDate(dmy) {
  const [day, month, year] = dmy.split("/");
  return new Date(`${year}-${month}-${day}`);
}

export const {
  setPlaceData,
  setSearchCardData,
  setSelectedRoomRate,
  setSearchToggle,
  setSearchCardFocus
} = searchCardData.actions;
export default searchCardData.reducer;
